import { IsNotEmpty, IsString } from 'class-validator';

export class NameNewVideoFormInfo {
    @IsString()
    @IsNotEmpty({ message: 'Navnet på videoen må fylles ut.' })
    name: string;
}
